import { h, render, Fragment } from 'preact'
import styled from 'styled-components'
import { RowTitle, RowDescription } from '../style'
import { Status, resolveStatus } from '../components'

const Wrapper = styled.div`
  display: flex;
  margin: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 0 5px 10px;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`

const Metadata = styled.div`
  display: flex;
  flex-direction: column;
`

const Title = styled.div`
  ${RowTitle}
`

const Description = styled.div`
  ${RowDescription}
`

export const EntryRow = ({ data, onClick }) => {
  const status = resolveStatus(data)
  let description = 'Awaiting upload...'

  if (status === 'uploading' && data.source_uploaded) {
    description = 'Uploading to origin server...'
  }
  if (status === 'converting') {
    description = 'Converting...'
  }
  if (status === 'ready') {
    description = 'Ready for playback'
  }

  return (
    <Wrapper onClick={onClick}>
      <Status data={data} />
      <Metadata>
        <Title>{data.name}</Title>
        <Description>{description}</Description>
      </Metadata>
    </Wrapper>
  )
}
